import { useEffect } from 'react';
import { usePriorityRendererShallowStore } from '../store/priority-renderer.store';

export const useInitPriorityRendererGroup = ({
  groupName,
  priorityList,
  resetPriorityMap = false,
  stabilizationTimeout,
  enabled = true,
}: {
  groupName: string;
  priorityList: string[];
  resetPriorityMap?: boolean;
  /**
   * Time in milliseconds to wait for all items to register before stabilizing the group.
   * Once stabilized, the top priority item becomes visible.
   * Default is 150ms.
   */
  stabilizationTimeout?: number;
  enabled?: boolean;
}) => {
  const { initializeGroup } = usePriorityRendererShallowStore('initializeGroup');

  useEffect(() => {
    if (!enabled) return;
    initializeGroup?.({ groupName, priorityList, resetPriorityMap, stabilizationTimeout });
  }, [enabled, groupName, initializeGroup, priorityList, resetPriorityMap, stabilizationTimeout]);
};
